import { FieldValidationSignature } from '.'
import { NumberField } from 'ui'
import { usePDFStore } from '../../../stores/pdf.store'
import { INT_MAX_VALUE } from 'bff'

export const FieldValidationLength: FieldValidationSignature = ({ field }) => {
  const updateField = usePDFStore((state) => state.updateField)

  return (
    <div className='flex flex-col space-y-5'>
      <div>
        <label className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'>
          Mínimo cantidad de caracteres
        </label>
        <NumberField
          size={'sm'}
          minValue={0}
          maxValue={INT_MAX_VALUE}
          defaultValue={field.min_length!}
          onChange={(value) =>
            updateField(field.id, {
              min_length: value,
            })
          }
        />
      </div>
      <div>
        <label className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'>
          Maxima cantidad de caracteres
        </label>
        <NumberField
          minValue={0}
          maxValue={INT_MAX_VALUE}
          size={'sm'}
          defaultValue={field.max_length!}
          onChange={(value) =>
            updateField(field.id, {
              max_length: value,
            })
          }
        />
      </div>
    </div>
  )
}
